import React from "react";
import Select from "react-select";

export const options = [
  {
    value: "Позоришта",
    label: "Позоришта",
  },
  {
    value: "Музеји и галерије са фондом ",
    label: "Музеји и галерије са фондом ",
  },
  {
    value: "Библиотеке",
    label: "Библиотеке",
  },
  {
    value: "Биоскопи",
    label: "Биоскопи",
  },
];

const SelectDropdown = ({ getVal, selected }) => {
  const handleChange = (selectedOption) => {
    getVal(selectedOption);
  };

  return (
    <div className="select-dropdown">
      <Select
        isMulti
        options={options}
        placeholder="Изаберите тип установе..."
        onChange={handleChange}
        value={selected}
      />
    </div>
  );
};

export default SelectDropdown;
